import { Form, Input } from 'antd'
import type { Rule } from 'antd/es/form'
import { FC } from 'react'
import UniversalColorPicker from './universal-color-picker'
import type { UniversalColorValue } from '../../types/pantone-color'

type FieldMapping = {
    /** Form field for color name (Color.name / colorName) */
    name: string
    /** Form field for hex (Color.code / color) */
    hex: string
}

type UniversalColorFormFieldsProps = {
    fields: FieldMapping
    label?: string
    disabled?: boolean
}

const requiredColorRules: Rule[] = [
    {
        validator: async (_, value) => {
            if (value === undefined || value === null || value === '') {
                return Promise.reject(new Error('Обязательное поле'))
            }
        },
    },
]

/**
 * Syncs UniversalColorPicker with two separate Form fields (e.g. color + colorName).
 */
export const UniversalColorFormFields: FC<UniversalColorFormFieldsProps> = ({
    fields,
    label = 'Цвет',
    disabled,
}) => {
    const form = Form.useFormInstance()
    const nameVal = Form.useWatch(fields.name, form) as string | undefined
    const hexVal = Form.useWatch(fields.hex, form) as string | undefined

    const pickerValue =
        nameVal || hexVal ? { name: nameVal ?? '', hex: hexVal ?? '' } : undefined

    const onChange = (next: UniversalColorValue) => {
        form.setFieldsValue({
            [fields.name]: next.name,
            [fields.hex]: next.hex,
        })
    }

    return (
        <>
            <Form.Item name={fields.hex} hidden rules={requiredColorRules}>
                <Input />
            </Form.Item>
            <Form.Item name={fields.name} hidden rules={requiredColorRules}>
                <Input />
            </Form.Item>
            <Form.Item label={label} required>
                <UniversalColorPicker value={pickerValue} onChange={onChange} disabled={disabled} />
            </Form.Item>
        </>
    )
}
